import React from 'react';
import { Link } from 'react-router-dom';
import LoretoGlyph from './LoretoGlyph';

/**
 * "x402 payments enabled" — ours, not a third party's.
 *
 * It sits beside the CodeHype and Product Hunt badges, which are both remote
 * images on somebody else's CDN. This one is drawn in the page: it carries the
 * Loreto mark rather than a generic coin, matches the site's type exactly at
 * any zoom, costs no request, and cannot go stale or disappear when a vendor
 * reorganises their assets.
 *
 * The wording is checked against /api/portal/x402/info rather than assumed:
 * enabled, mode mainnet, USDC on Base (eip155:8453). If that endpoint is ever
 * flipped back to a testnet, the second line here is the thing that becomes a
 * lie, so it is the thing to change.
 */
export default function X402Badge({ className = '' }) {
  return (
    <Link
      to="/docs#x402"
      aria-label="x402 payments enabled — pay per call in USDC on Base. Read the docs."
      className={`group inline-flex items-center gap-3 rounded-full border border-[var(--border-2)]
                  bg-[var(--bg-2)] pl-2.5 pr-5 py-2 transition-colors
                  hover:border-[var(--accent)] ${className}`}
    >
      <span
        className="grid place-items-center w-9 h-9 rounded-full shrink-0
                   border border-[var(--accent)] bg-[rgba(212,165,116,0.10)]"
        aria-hidden="true"
      >
        <LoretoGlyph size={19} glyph="var(--accent)" rule="var(--accent)" title="" />
      </span>
      <span className="leading-none text-left">
        <span className="block mono text-[0.76rem] tracking-[0.04em] text-[var(--text)]">
          x402 payments enabled
        </span>
        <span className="block mono text-[0.58rem] tracking-[0.2em] uppercase text-[var(--text-3)] mt-[5px]">
          USDC on Base · no account
        </span>
      </span>
    </Link>
  );
}
